const acessoFeitoNoResumoDaInscricao = (locationState) => {
  return locationState ? locationState.acessoFeitoNoResumoDaInscricao : false;
};

export default acessoFeitoNoResumoDaInscricao;